import { useUi } from '@/stores/ui';

export function ThemeToggle() {
  const theme = useUi((s) => s.theme);
  const toggle = useUi((s) => s.toggleTheme);

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'}
      style={{ padding: '4px 10px', fontSize: 'var(--text-xs)' }}
    >
      {theme === 'dark' ? 'Light' : 'Dark'}
    </button>
  );
}
